<template>
  <div class="innerItem settingOrder">
    <div>
      <p class="innerTitle setLabel">{{locale.setting_room_mypage_display}}</p>
      <div class="mb15">
        <div class="checkbox">
          <input type="checkbox" id="mypage_room" v-model="mypage.disabledRoom">
          <label for="mypage_room">{{locale.setting_room_disabled}}</label>
        </div>
      </div>
      <div class="mb15">
        <div class="checkbox">
          <input type="checkbox" id="mypage_navcart" v-model="mypage.disabledCart">
          <label for="mypage_navcart">{{locale.setting_cart_disabled}}</label>
        </div>
      </div>
      <div class="mb30">
        <div class="checkbox">
          <input type="checkbox" id="mypage_disabled_mypage" v-model="mypage.disabledMypage">
          <label for="mypage_disabled_mypage">{{locale.setting_mypage_disabled}}</label>
        </div>
      </div>
      <div :class="{disabled: mypage.disabledMypage}">
        <p class="innerTitle setLabel">{{locale.mypage}}</p>
        <p v-if="!mypage.disabledMypage" class="sysMessage">{{locale.setting_mypage_message}}</p>
        <div class="mt10 mb15 checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_coupon" :disabled="disabled('coupon')" v-model="mypage.coupon">
            <label for="mypage_coupon">{{locale.display_coupon}}</label>
          </div>
        </div>
        <div class="mb15 checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_cart" :disabled="disabled('cart')" v-model="mypage.cart">
            <label for="mypage_cart">({{ locale.mypage }}) {{locale.display_cart}}</label>
          </div>
        </div>
        <div class="mb15 checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_order" :disabled="disabled('order')" v-model="mypage.order">
            <label for="mypage_order">{{locale.display_order}}</label>
          </div>
        </div>
        <div class="mb15 checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_payment" :disabled="disabled('payment')" v-model="mypage.payment">
            <label for="mypage_payment">{{locale.display_payment}}</label>
          </div>
        </div>
        <div class="mb15 checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_reservation" :disabled="disabled('reservation')" v-model="mypage.reservation">
            <label for="mypage_reservation">{{locale.display_reservation}}</label>
          </div>
        </div>
        <div class="checkOption">
          <div class="checkbox">
            <input type="checkbox" id="mypage_mobility" :disabled="disabled('mobility')" v-model="mypage.mobility">
            <label for="mypage_mobility">{{locale.display_mobility}}</label>
          </div>
        </div>
      </div>
      
      <!-- <div class="mt10 mb5">
        <div class="checkbox">
          <input type="checkbox" id="mypage_disabled_cart" v-model="mypage.disabledCart">
          <label for="mypage_disabled_cart">메뉴바에 장바구니 숨김</label>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetMypage',
  props: [
    'locale',
    'mypage'
  ],
  data () {
    return {
    }
  },
  methods: {
    disabled (key) {
      const setting = /coupon|cart|order|payment|reservation|mobility/
      const mypage = Object.keys(this.mypage).filter(x => setting.test(x)).map(x => {
        return {
          id: x,
          isChecked: this.mypage[x]
        }
      })
      const isDisabled = this.mypage.disabledMypage
      const isChecked = this.mypage[key]
      return !isDisabled && isChecked && mypage.filter(x => x.isChecked).length <= 1
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  .checkOption {
    opacity: 0.5;
  }
}
</style>
